var React = require('react');

function GrayLockInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.66634 9.16667H6.83301C6.28072 9.16667 5.83301 9.61438 5.83301 10.1667V14C5.83301 14.5523 6.28072 15 6.83301 15H13.1663C13.7186 15 14.1663 14.5523 14.1663 14V10.1667C14.1663 9.61438 13.7186 9.16667 13.1663 9.16667H13.333C13.333 6.52778 12.1872 5 9.99967 5C7.81217 5 6.66634 6.52778 6.66634 9.16667ZM11.6663 9.16667C11.6663 7.36111 11.1455 6.66667 9.99967 6.66667C8.85384 6.66667 8.33301 7.36111 8.33301 9.16667H11.6663Z","fill":"#99A1B0"}));
}

GrayLockInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = GrayLockInline;

GrayLockInline.default = GrayLockInline;
